export const WellTypes = {
  DRINKING: 'Drinking',
  NON_DRINKING: 'Non drinking',
};
